export const movieList = [
  {
    id: 'star-echo',
    title: '星际回声',
    year: 2024,
    regions: ['大陆'],
    genres: ['科幻', '冒险', '剧情'],
    rating: 8.7,
    duration: '128分钟',
    director: '程亦舟',
    cast: ['沈知远', '顾清', '陆行舟', '白露'],
    synopsis:
      '一支远航勘测队在废弃空间站接收到一段来自三十年前的求救信号，信号的发出者正是队长失踪多年的父亲。随着回应信号被逐层解码，队员们发现所谓的救援行动，其实是一场精心设计的返航实验。',
    cover:
      'https://readdy.ai/api/search-image?query=lone%20astronaut%20silhouette%20standing%20on%20a%20reflective%20alien%20plain%20facing%20a%20giant%20glowing%20planet%20ring%2C%20distant%20stars%20and%20atmospheric%20haze%2C%20cinematic%20film%20poster%20artwork%2C%20deep%20navy%20and%20warm%20amber%20palette%2C%20dramatic%20rim%20lighting%2C%20clean%20minimal%20composition%2C%20no%20text%2C%20highly%20detailed%20editorial%20illustration&width=600&height=800&seq=md-poster-movie-01&orientation=portrait',
    backdrop:
      'https://readdy.ai/api/search-image?query=wide%20cinematic%20sci%20fi%20landscape%20with%20a%20small%20astronaut%20figure%20facing%20an%20enormous%20planet%20ring%20in%20deep%20space%2C%20drifting%20dust%20and%20soft%20nebula%20glow%2C%20deep%20navy%20blue%20and%20amber%20tones%2C%20atmospheric%20film%20still%20background%2C%20no%20text%2C%20high%20detail&width=1600&height=900&seq=md-backdrop-movie-01&orientation=landscape',
    tags: ['太空', '人性', '悬疑'],
    popularity: 9820,
    updatedAt: '2025-09-18',
  },
  {
    id: 'deep-signal',
    title: '深海信号',
    year: 2023,
    regions: ['香港'],
    genres: ['悬疑', '惊悚'],
    rating: 8.2,
    duration: '112分钟',
    director: '何允行',
    cast: ['苏文山', '林知夏', '郑一鸣'],
    synopsis:
      '一艘退役深潜器在例行检修时捕捉到规律性的敲击声，声音来自海沟底部一座未被记录的金属结构。潜水员方渡在返航后开始出现时间错位的记忆，而唯一的线索，是那段敲击声里反复出现的三个数字。',
    cover:
      'https://readdy.ai/api/search-image?query=deep%20sea%20submarine%20with%20searchlight%20beams%20cutting%20through%20dark%20water%2C%20suspended%20particles%20and%20mysterious%20sonar%20glow%20below%2C%20cinematic%20film%20poster%20artwork%2C%20deep%20navy%20and%20warm%20amber%20palette%2C%20dramatic%20rim%20lighting%2C%20clean%20minimal%20composition%2C%20no%20text%2C%20highly%20detailed%20editorial%20illustration&width=600&height=800&seq=md-poster-movie-02&orientation=portrait',
    tags: ['深海', '心理', '惊悚'],
    popularity: 8640,
    updatedAt: '2025-08-30',
  },
  {
    id: 'endless-night',
    title: '长夜将尽',
    year: 2022,
    regions: ['欧美'],
    genres: ['剧情', '犯罪'],
    rating: 8.9,
    duration: '134分钟',
    director: 'Elias Moreau',
    cast: ['Adrian Vale', 'Nora Keller', 'Miles Rowe'],
    synopsis:
      '一名即将退休的夜班警探在最后一周接到一桩看似普通的失踪案。随着调查深入，他发现自己二十年前签字结案的一份档案，正以同样的方式重新出现在城市的雨夜里。',
    cover:
      'https://readdy.ai/api/search-image?query=rain%20soaked%20neon%20city%20street%20at%20midnight%20with%20a%20lone%20figure%20in%20a%20long%20coat%20walking%20away%2C%20reflective%20asphalt%20and%20distant%20tail%20lights%2C%20cinematic%20film%20poster%20artwork%2C%20deep%20navy%20and%20warm%20amber%20palette%2C%20dramatic%20rim%20lighting%2C%20no%20text%2C%20highly%20detailed%20editorial%20illustration&width=600&height=800&seq=md-poster-movie-03&orientation=portrait',
    tags: ['黑色电影', '警探', '雨夜'],
    popularity: 9310,
    updatedAt: '2025-09-02',
  },
  {
    id: 'spring-wind',
    title: '春风不度',
    year: 2024,
    regions: ['大陆'],
    genres: ['剧情', '爱情'],
    rating: 7.8,
    duration: '116分钟',
    director: '许南',
    cast: ['周也青', '宋岸', '何棠'],
    synopsis:
      '南方小城的旧电影院即将拆除，一对多年未见的旧友在最后一场放映里重逢。他们用一整晚的时间，把当年没有说完的话，一句一句补进空荡荡的放映厅。',
    cover:
      'https://readdy.ai/api/search-image?query=two%20young%20people%20sitting%20on%20a%20rooftop%20at%20golden%20dusk%20surrounded%20by%20paper%20lanterns%2C%20warm%20spring%20haze%20and%20soft%20bokeh%2C%20cinematic%20film%20poster%20artwork%2C%20deep%20navy%20and%20warm%20amber%20palette%2C%20gentle%20rim%20lighting%2C%20clean%20minimal%20composition%2C%20no%20text%2C%20highly%20detailed%20editorial%20illustration&width=600&height=800&seq=md-poster-movie-04&orientation=portrait',
    tags: ['文艺', '小城', '重逢'],
    popularity: 6980,
    updatedAt: '2025-07-21',
  },
  {
    id: 'iron-border',
    title: '铁血边界',
    year: 2021,
    regions: ['欧美'],
    genres: ['动作', '战争'],
    rating: 8.1,
    duration: '141分钟',
    director: 'Marcus Hale',
    cast: ['Owen Brant', 'Lena Ford', 'Ruben Diaz'],
    synopsis:
      '一支边境护送小队在穿越山谷时遭遇伏击，通讯中断、补给耗尽。队长必须在四十八小时内带着一份停战文件抵达哨所，而队伍里有人并不希望这份文件送达。',
    cover:
      'https://readdy.ai/api/search-image?query=soldiers%20silhouette%20crossing%20a%20dusty%20mountain%20ridge%20at%20dawn%20with%20an%20armored%20vehicle%2C%20dramatic%20dust%20clouds%20and%20low%20sunlight%2C%20cinematic%20film%20poster%20artwork%2C%20deep%20navy%20and%20warm%20amber%20palette%2C%20strong%20backlighting%2C%20no%20text%2C%20highly%20detailed%20editorial%20illustration&width=600&height=800&seq=md-poster-movie-05&orientation=portrait',
    tags: ['战争', '兄弟情', '护送'],
    popularity: 7780,
    updatedAt: '2025-06-11',
  },
  {
    id: 'fog-harbor',
    title: '雾港谜案',
    year: 2023,
    regions: ['香港'],
    genres: ['悬疑', '犯罪'],
    rating: 8.4,
    duration: '108分钟',
    director: '陈启川',
    cast: ['麦子朗', '黄静之', '谭昊'],
    synopsis:
      '集装箱码头连续三晚在同一位置发现无名行李箱，箱内只有一张旧船票。重案组督察与港口调度员联手排查，逐渐拼出一桩跨越十五年的走私旧案。',
    cover:
      'https://readdy.ai/api/search-image?query=foggy%20harbor%20with%20stacked%20shipping%20containers%20and%20a%20single%20hanging%20lamp%2C%20silhouette%20of%20a%20detective%20standing%20on%20a%20pier%2C%20cinematic%20film%20poster%20artwork%2C%20deep%20navy%20and%20warm%20amber%20palette%2C%20dramatic%20rim%20lighting%2C%20no%20text%2C%20highly%20detailed%20editorial%20illustration&width=600&height=800&seq=md-poster-movie-06&orientation=portrait',
    tags: ['港片', '推理', '码头'],
    popularity: 8420,
    updatedAt: '2025-05-28',
  },
  {
    id: 'summer-echo',
    title: '夏日回声',
    year: 2025,
    regions: ['日韩'],
    genres: ['青春', '爱情'],
    rating: 7.9,
    duration: '104分钟',
    director: '宫野凉',
    cast: ['井上葵', '木村晴', '佐藤凛'],
    synopsis:
      '海边小镇的夏天，四个高中生在废弃车站录下一盘磁带，约定十年后一起打开。十年后的同一天，只有一个人回到了站台，而那盘磁带已经开始褪色。',
    cover:
      'https://readdy.ai/api/search-image?query=teenagers%20on%20a%20seaside%20railway%20platform%20in%20summer%20with%20sun%20flare%20and%20waving%20hands%2C%20nostalgic%20film%20tones%20and%20soft%20grain%2C%20cinematic%20film%20poster%20artwork%2C%20deep%20navy%20and%20warm%20amber%20palette%2C%20gentle%20lighting%2C%20no%20text%2C%20highly%20detailed%20editorial%20illustration&width=600&height=800&seq=md-poster-movie-07&orientation=portrait',
    tags: ['青春', '海边', '怀旧'],
    popularity: 7210,
    updatedAt: '2025-10-02',
  },
  {
    id: 'upstream',
    title: '逆流而上',
    year: 2020,
    regions: ['大陆'],
    genres: ['剧情', '运动'],
    rating: 8.3,
    duration: '122分钟',
    director: '梁书恒',
    cast: ['季川', '罗小满', '陈砚'],
    synopsis:
      '因伤退役的游泳运动员回到县城，成了少年体校的临时教练。他要带的第一个学生，是当年对手的儿子，而这个孩子怕水。',
    cover:
      'https://readdy.ai/api/search-image?query=competitive%20swimmer%20cutting%20through%20dark%20pool%20water%20with%20dramatic%20overhead%20light%2C%20frozen%20water%20droplets%20and%20ripples%2C%20cinematic%20film%20poster%20artwork%2C%20deep%20navy%20and%20warm%20amber%20palette%2C%20strong%20contrast%20lighting%2C%20no%20text%2C%20highly%20detailed%20editorial%20illustration&width=600&height=800&seq=md-poster-movie-08&orientation=portrait',
    tags: ['励志', '游泳', '师徒'],
    popularity: 6650,
    updatedAt: '2025-04-19',
  },
  {
    id: 'beyond-dunes',
    title: '沙丘之外',
    year: 2024,
    regions: ['欧美'],
    genres: ['科幻', '冒险'],
    rating: 8.6,
    duration: '152分钟',
    director: 'Iris Bellamy',
    cast: ['Tomas Reid', 'Yara Nabil', 'Colin Ashe'],
    synopsis:
      '沙海深处的水源勘探队救下一名失去记忆的旅人，他手腕上的旧式记录仪里，存着一条通往传说中绿洲的坐标，也存着队伍中某个人的名字。',
    cover:
      'https://readdy.ai/api/search-image?query=vast%20desert%20dunes%20with%20a%20tiny%20caravan%20under%20an%20enormous%20amber%20sun%2C%20wind%20ripples%20in%20sand%20and%20dust%20haze%2C%20cinematic%20film%20poster%20artwork%2C%20deep%20navy%20and%20warm%20amber%20palette%2C%20dramatic%20rim%20lighting%2C%20no%20text%2C%20highly%20detailed%20editorial%20illustration&width=600&height=800&seq=md-poster-movie-09&orientation=portrait',
    backdrop:
      'https://readdy.ai/api/search-image?query=sweeping%20desert%20dunes%20at%20golden%20hour%20with%20a%20small%20caravan%20crossing%20the%20ridge%2C%20huge%20amber%20sun%20and%20wind%20blown%20sand%2C%20deep%20navy%20shadows%20and%20warm%20light%2C%20epic%20cinematic%20film%20still%20background%2C%20no%20text%2C%20high%20detail&width=1600&height=900&seq=md-backdrop-movie-09&orientation=landscape',
    tags: ['沙海', '旅途', '史诗'],
    popularity: 9540,
    updatedAt: '2025-09-26',
  },
  {
    id: 'homeward-train',
    title: '归途列车',
    year: 2019,
    regions: ['大陆'],
    genres: ['剧情', '家庭'],
    rating: 8.8,
    duration: '118分钟',
    director: '傅连山',
    cast: ['邵云', '李满仓', '穆青'],
    synopsis:
      '春运前的最后一趟绿皮车上，一位带着父亲骨灰盒的中年男人，与一个偷偷离家出走的少年邻座。二十六个小时的旅程里，两个人各自完成了一次回家。',
    cover:
      'https://readdy.ai/api/search-image?query=green%20slow%20train%20crossing%20snowy%20countryside%20at%20dusk%20with%20warm%20window%20lights%2C%20distant%20village%20and%20falling%20snow%2C%20cinematic%20film%20poster%20artwork%2C%20deep%20navy%20and%20warm%20amber%20palette%2C%20gentle%20lighting%2C%20no%20text%2C%20highly%20detailed%20editorial%20illustration&width=600&height=800&seq=md-poster-movie-10&orientation=portrait',
    tags: ['家庭', '春运', '公路'],
    popularity: 8890,
    updatedAt: '2025-03-08',
  },
  {
    id: 'midnight-chase',
    title: '零点追凶',
    year: 2025,
    regions: ['香港'],
    genres: ['动作', '悬疑'],
    rating: 8.0,
    duration: '119分钟',
    director: '雷坚',
    cast: ['高翊', '邓婉仪', '方鹤'],
    synopsis:
      '零点前的七分钟里，城市中心的三座天台同时出现不明信号。重案组与网络安全顾问被锁在同一场追逐中，而倒计时的终点，指向一份从未公开的名单。',
    cover:
      'https://readdy.ai/api/search-image?query=action%20chase%20on%20a%20wet%20rooftop%20at%20night%20with%20city%20skyline%20bokeh%20and%20motion%20blur%2C%20dramatic%20backlight%20silhouette%2C%20cinematic%20film%20poster%20artwork%2C%20deep%20navy%20and%20warm%20amber%20palette%2C%20strong%20contrast%20lighting%2C%20no%20text%2C%20highly%20detailed%20editorial%20illustration&width=600&height=800&seq=md-poster-movie-11&orientation=portrait',
    backdrop:
      'https://readdy.ai/api/search-image?query=night%20rooftop%20chase%20above%20a%20glowing%20city%20skyline%2C%20rain%20slick%20surfaces%20and%20long%20light%20trails%2C%20deep%20navy%20shadows%20with%20amber%20street%20glow%2C%20cinematic%20action%20film%20still%20background%2C%20no%20text%2C%20high%20detail&width=1600&height=900&seq=md-backdrop-movie-11&orientation=landscape',
    tags: ['动作', '倒计时', '港式'],
    popularity: 8120,
    updatedAt: '2025-10-11',
  },
  {
    id: 'white-corridor',
    title: '白色回廊',
    year: 2022,
    regions: ['日韩'],
    genres: ['惊悚', '悬疑'],
    rating: 8.2,
    duration: '101分钟',
    director: '南条圭',
    cast: ['森川遥', '石田澪', '影山悟'],
    synopsis:
      '夜班护士在空无一人的旧病区听见呼叫铃反复响起，声音来自一间早已封闭的病房。她推开门后，走廊的长度开始和她记忆里的不太一样。',
    cover:
      'https://readdy.ai/api/search-image?query=empty%20white%20hospital%20corridor%20with%20a%20flickering%20ceiling%20light%20and%20a%20distant%20figure%2C%20unsettling%20symmetry%20and%20cold%20haze%2C%20cinematic%20film%20poster%20artwork%2C%20deep%20navy%20and%20warm%20amber%20accents%2C%20dramatic%20lighting%2C%20no%20text%2C%20highly%20detailed%20editorial%20illustration&width=600&height=800&seq=md-poster-movie-12&orientation=portrait',
    tags: ['心理惊悚', '医院', '密室'],
    popularity: 7480,
    updatedAt: '2025-02-14',
  },
];

export const tvList = [
  {
    id: 'mist-city',
    title: '迷雾之城',
    year: 2024,
    regions: ['大陆'],
    genres: ['悬疑', '犯罪'],
    rating: 8.9,
    duration: '45分钟/集',
    director: '韩竞',
    cast: ['程野', '鹿鸣', '苏念', '段青'],
    synopsis:
      '连续七天的大雾笼罩整座城市，六起毫无关联的案件在同一条地铁线上发生。刑警队长与初出茅庐的画像师组成临时搭档，追踪一个从不留下指纹的人。',
    cover:
      'https://readdy.ai/api/search-image?query=dense%20fog%20covering%20a%20modern%20city%20skyline%20with%20one%20glowing%20tower%20and%20river%20reflection%2C%20moody%20atmosphere%2C%20cinematic%20series%20poster%20artwork%2C%20deep%20navy%20and%20warm%20amber%20palette%2C%20dramatic%20rim%20lighting%2C%20no%20text%2C%20highly%20detailed%20editorial%20illustration&width=600&height=800&seq=md-poster-tv-01&orientation=portrait',
    backdrop:
      'https://readdy.ai/api/search-image?query=wide%20cinematic%20view%20of%20a%20fog%20covered%20city%20at%20night%20with%20one%20warm%20lit%20tower%20and%20rain%20streaked%20river%2C%20deep%20navy%20blue%20and%20amber%20tones%2C%20mysterious%20series%20still%20background%2C%20no%20text%2C%20high%20detail&width=1600&height=900&seq=md-backdrop-tv-01&orientation=landscape',
    tags: ['悬疑', '搭档', '城市'],
    popularity: 9980,
    updatedAt: '2025-10-14',
    episodeCount: 24,
  },
  {
    id: 'changan-night',
    title: '长安夜行',
    year: 2023,
    regions: ['大陆'],
    genres: ['古装', '剧情', '悬疑'],
    rating: 9.1,
    duration: '48分钟/集',
    director: '薛怀安',
    cast: ['靳北辰', '温书玉', '裴照', '林知白'],
    synopsis:
      '上元灯节前夜，长安城的更鼓少敲了三声。一名被贬的小吏与一位西域来的画师循着灯市里的线索，走进一场围绕旧年宫变的漫长夜色。',
    cover:
      'https://readdy.ai/api/search-image?query=ancient%20chinese%20city%20at%20night%20with%20glowing%20lanterns%2C%20tiled%20roofs%20and%20distant%20palace%20silhouette%20in%20mist%2C%20cinematic%20series%20poster%20artwork%2C%20deep%20navy%20and%20warm%20amber%20palette%2C%20dramatic%20lighting%2C%20no%20text%2C%20highly%20detailed%20editorial%20illustration&width=600&height=800&seq=md-poster-tv-02&orientation=portrait',
    backdrop:
      'https://readdy.ai/api/search-image?query=ancient%20chinese%20lantern%20festival%20street%20at%20night%20seen%20from%20above%2C%20rows%20of%20warm%20glowing%20lanterns%20and%20tiled%20rooftops%20fading%20into%20mist%2C%20deep%20navy%20sky%20with%20amber%20light%2C%20cinematic%20period%20drama%20still%20background%2C%20no%20text%2C%20high%20detail&width=1600&height=900&seq=md-backdrop-tv-02&orientation=landscape',
    tags: ['古装', '探案', '长安'],
    popularity: 9860,
    updatedAt: '2025-10-10',
    episodeCount: 36,
  },
  {
    id: 'blue-horizon',
    title: '蓝色边界',
    year: 2022,
    regions: ['欧美'],
    genres: ['科幻', '剧情'],
    rating: 8.5,
    duration: '52分钟/集',
    director: 'Sofia Lindqvist',
    cast: ['Erin Vale', 'Jonas Berg', 'Mira Chen'],
    synopsis:
      '近地轨道站上的六名观测员负责监测地球磁场，一次长达九分钟的通讯静默之后，他们发现地面传来的指令，日期比空间站日历晚了三年。',
    cover:
      'https://readdy.ai/api/search-image?query=space%20station%20window%20overlooking%20a%20blue%20planet%20with%20an%20astronaut%20silhouette%20and%20cool%20interior%20light%2C%20cinematic%20series%20poster%20artwork%2C%20deep%20navy%20and%20warm%20amber%20accents%2C%20dramatic%20rim%20lighting%2C%20no%20text%2C%20highly%20detailed%20editorial%20illustration&width=600&height=800&seq=md-poster-tv-03&orientation=portrait',
    tags: ['太空', '时间', '硬科幻'],
    popularity: 8060,
    updatedAt: '2025-08-22',
    episodeCount: 12,
  },
  {
    id: 'city-glimmer',
    title: '都市微光',
    year: 2025,
    regions: ['大陆'],
    genres: ['都市', '情感'],
    rating: 8.0,
    duration: '42分钟/集',
    director: '沈一苇',
    cast: ['祁夏', '周迟', '白果', '许岸'],
    synopsis:
      '同一栋旧居民楼里的四户人家，因为一次深夜停电彼此熟络起来。修不好的电梯、临时搭起的饭桌和一盏总在闪烁的廊灯，串起了他们这一年的生活。',
    cover:
      'https://readdy.ai/api/search-image?query=warm%20apartment%20windows%20glowing%20at%20night%20across%20an%20old%20city%20block%20with%20gentle%20rain%2C%20cozy%20interior%20light%20and%20silhouettes%2C%20cinematic%20series%20poster%20artwork%2C%20deep%20navy%20and%20warm%20amber%20palette%2C%20soft%20lighting%2C%20no%20text%2C%20highly%20detailed%20editorial%20illustration&width=600&height=800&seq=md-poster-tv-04&orientation=portrait',
    tags: ['都市', '群像', '治愈'],
    popularity: 7640,
    updatedAt: '2025-09-30',
    episodeCount: 30,
  },
  {
    id: 'silent-testimony',
    title: '无声证词',
    year: 2024,
    regions: ['香港'],
    genres: ['悬疑', '律政'],
    rating: 8.7,
    duration: '44分钟/集',
    director: '柯正楠',
    cast: ['岑志远', '何嘉言', '罗天'],
    synopsis:
      '一名手语翻译被临时指派到一桩旧案重审现场，被告全程沉默。随着庭审推进，她意识到自己翻译的每一句话，都在悄悄改变这个案子的方向。',
    cover:
      'https://readdy.ai/api/search-image?query=empty%20courtroom%20with%20shafts%20of%20light%20through%20tall%20windows%20and%20a%20single%20document%20on%20the%20table%2C%20dust%20in%20the%20air%2C%20cinematic%20series%20poster%20artwork%2C%20deep%20navy%20and%20warm%20amber%20palette%2C%20dramatic%20lighting%2C%20no%20text%2C%20highly%20detailed%20editorial%20illustration&width=600&height=800&seq=md-poster-tv-05&orientation=portrait',
    tags: ['律政', '手语', '重审'],
    popularity: 8480,
    updatedAt: '2025-09-12',
    episodeCount: 20,
  },
  {
    id: 'shanhai-diner',
    title: '山海食堂',
    year: 2023,
    regions: ['日韩'],
    genres: ['治愈', '美食'],
    rating: 8.4,
    duration: '28分钟/集',
    director: '小野千寻',
    cast: ['藤井遥', '中村绫', '松本圭'],
    synopsis:
      '海边小镇上一间只在夜里营业的小食堂，菜单只有一页。老板从不问客人想吃什么，只问一句：今天过得怎么样。',
    cover:
      'https://readdy.ai/api/search-image?query=rustic%20japanese%20style%20eatery%20counter%20at%20night%20with%20steam%20rising%20from%20bowls%20and%20warm%20paper%20lanterns%2C%20wooden%20textures%2C%20cinematic%20series%20poster%20artwork%2C%20deep%20navy%20and%20warm%20amber%20palette%2C%20cozy%20lighting%2C%20no%20text%2C%20highly%20detailed%20editorial%20illustration&width=600&height=800&seq=md-poster-tv-06&orientation=portrait',
    tags: ['美食', '治愈', '深夜'],
    popularity: 7160,
    updatedAt: '2025-07-06',
    episodeCount: 16,
  },
  {
    id: 'er-night-shift',
    title: '急诊夜班',
    year: 2021,
    regions: ['大陆'],
    genres: ['剧情', '医疗'],
    rating: 8.6,
    duration: '46分钟/集',
    director: '徐立',
    cast: ['孟川', '姜莱', '龚亦', '谢寻'],
    synopsis:
      '城市中心医院急诊科的十二小时夜班，从一场连环车祸开始。医生、护士、家属与救护车司机，在同一盏白炽灯下做出各自的选择。',
    cover:
      'https://readdy.ai/api/search-image?query=hospital%20emergency%20corridor%20at%20night%20with%20cool%20white%20light%20and%20medical%20staff%20silhouettes%20rushing%2C%20reflective%20floor%2C%20cinematic%20series%20poster%20artwork%2C%20deep%20navy%20and%20warm%20amber%20accents%2C%20dramatic%20lighting%2C%20no%20text%2C%20highly%20detailed%20editorial%20illustration&width=600&height=800&seq=md-poster-tv-07&orientation=portrait',
    tags: ['医疗', '群像', '夜班'],
    popularity: 7920,
    updatedAt: '2025-05-16',
    episodeCount: 28,
  },
  {
    id: 'undercurrent',
    title: '暗涌',
    year: 2025,
    regions: ['欧美'],
    genres: ['犯罪', '惊悚'],
    rating: 8.3,
    duration: '50分钟/集',
    director: 'Noah Sterling',
    cast: ['Dylan Cross', 'Ivy Marsh', 'Sean Dooley'],
    synopsis:
      '港口城市的货代公司里，一名会计发现三年来所有的账目都对得上，只有一艘船的进出港记录多出了一个夜晚。她把这个发现告诉了不该告诉的人。',
    cover:
      'https://readdy.ai/api/search-image?query=dark%20harbor%20warehouse%20interior%20with%20crates%20and%20a%20single%20hanging%20light%2C%20two%20figures%20in%20shadow%20and%20fog%20outside%2C%20cinematic%20series%20poster%20artwork%2C%20deep%20navy%20and%20warm%20amber%20palette%2C%20dramatic%20rim%20lighting%2C%20no%20text%2C%20highly%20detailed%20editorial%20illustration&width=600&height=800&seq=md-poster-tv-08&orientation=portrait',
    tags: ['犯罪', '港口', '账目'],
    popularity: 8320,
    updatedAt: '2025-10-08',
    episodeCount: 10,
  },
  {
    id: 'fearless-youth',
    title: '少年不惧',
    year: 2022,
    regions: ['大陆'],
    genres: ['青春', '成长'],
    rating: 8.1,
    duration: '40分钟/集',
    director: '温可',
    cast: ['顾少白', '叶青禾', '孙一鸣'],
    synopsis:
      '县中学的篮球队因为人数不足面临解散，五个从没打过正式比赛的学生凑齐了名单。他们要赢下的第一场球，是对自己。',
    cover:
      'https://readdy.ai/api/search-image?query=school%20basketball%20court%20at%20sunset%20with%20students%20silhouettes%20and%20dust%20floating%20in%20golden%20light%2C%20chain%20fence%20and%20long%20shadows%2C%20cinematic%20series%20poster%20artwork%2C%20deep%20navy%20and%20warm%20amber%20palette%2C%20nostalgic%20lighting%2C%20no%20text%2C%20highly%20detailed%20editorial%20illustration&width=600&height=800&seq=md-poster-tv-09&orientation=portrait',
    tags: ['青春', '篮球', '校园'],
    popularity: 7040,
    updatedAt: '2025-06-24',
    episodeCount: 24,
  },
  {
    id: 'polar-beacon',
    title: '极地信标',
    year: 2024,
    regions: ['欧美'],
    genres: ['冒险', '科幻', '悬疑'],
    rating: 8.8,
    duration: '55分钟/集',
    director: 'Astrid Nilsen',
    cast: ['Freja Holm', 'Erik Sand', 'Nadia Osei'],
    synopsis:
      '极圈内的气象站每七年换一次驻站人员，这一批人到达时，发现上一批留下的记录停在四年前的冬至。屋里的咖啡还是温的。',
    cover:
      'https://readdy.ai/api/search-image?query=arctic%20research%20station%20under%20a%20green%20aurora%20sky%20with%20snow%20drifts%20and%20small%20warm%20lit%20windows%2C%20lone%20figure%20outside%2C%20cinematic%20series%20poster%20artwork%2C%20deep%20navy%20and%20warm%20amber%20palette%2C%20dramatic%20lighting%2C%20no%20text%2C%20highly%20detailed%20editorial%20illustration&width=600&height=800&seq=md-poster-tv-10&orientation=portrait',
    backdrop:
      'https://readdy.ai/api/search-image?query=remote%20arctic%20research%20station%20in%20deep%20snow%20beneath%20green%20aurora%20curtains%2C%20warm%20window%20light%20and%20endless%20blue%20white%20landscape%2C%20cinematic%20mystery%20series%20still%20background%2C%20no%20text%2C%20high%20detail&width=1600&height=900&seq=md-backdrop-tv-10&orientation=landscape',
    tags: ['极地', '失踪', '悬疑'],
    popularity: 9240,
    updatedAt: '2025-09-05',
    episodeCount: 8,
  },
];

export const featuredIds = [
  'star-echo',
  'mist-city',
  'beyond-dunes',
  'changan-night',
  'midnight-chase',
];